import { LogoType, Header, LanguageSwitcher } from '../../ui';
import { useTranslate } from 'hooks';
import Utils from 'utils/utils';
import styles from './index.module.scss';
import {DarkModeSwitcherMini} from "../../../DarkModeProvider";

export const LoginLayout = (props: any): JSX.Element => {
	const { top = null, children, bottom = null } = props;

	const { headLineRegisterText } = useTranslate(['headLineRegisterText']);

	return (
		<div className={styles.root}>
			<div className={styles.sider}>
				<a href={Utils.getLinkToWP('')}>
					<LogoType />
				</a>

				<div className={styles.wrapper}>
					<div className={styles.headline}>
						{headLineRegisterText}
						<span className={styles.specialChar}>.</span>
					</div>
				</div>
			</div>
			<div className={styles.content}>
				<Header>
					<div className={styles.headerLogin}>
						<div className={styles.logoWrapper}>
							<a href={Utils.getLinkToWP('')}>
								<LogoType />
							</a>
						</div>
						<div className={styles.menu}>{top}</div>
						<div className={styles.language}>
							<LanguageSwitcher />
						</div>
						<div className={styles.darkModeSwitcherMini}>
							<DarkModeSwitcherMini />
						</div>
					</div>
				</Header>

				<div className={styles.center}>
					<div className={styles.box}>{children}</div>
				</div>
				<div className={styles.bottom}>{bottom}</div>
			</div>
		</div>
	);
};
